__turbopack_context__.v({
  "container": "_1xpohG_container",
  "icon": "_1xpohG_icon",
  "list": "_1xpohG_list",
  "title": "_1xpohG_title",
});
